import React from 'react'

import { FieldKit } from 'containers/FormBuilder'
import ConditionTab from 'containers/VehicleSelection/ConditionTab'
import { FormikValues } from 'formik'

import { FormikTextInput } from '../../../components/FormikFields'
import AssetSubtype from '../../../state/enums/AssetSubtype'
import { ConditionTabWrapper, ComponentRow } from '../MarineWriteIn.styled'
import { YearDropdown } from './index'
import MakeDropdown from './MakeDropdown'
import { MARINE_CONDITION_ITEMS } from './marineConditionItems'

export interface Engine {
    condition: string
    year: string
    make: string
    model: string
}

interface Props {
    engine: Engine
    index: number
    formik: FieldKit<FormikValues>
    labelPrefix?: string
    prefilled?: boolean
}

function MotorFields({
    engine,
    index,
    formik,
    prefilled,
    labelPrefix,
}: Readonly<Props>) {
    const _labelPrefix = labelPrefix ?? `Motor #${index + 1}`

    return (
        <div>
            <ConditionTabWrapper>
                <ConditionTab
                    name={`marine.engines.[${index}].condition`}
                    label={`${_labelPrefix} Condition`}
                    items={MARINE_CONDITION_ITEMS}
                    prefilled={prefilled}
                />
            </ConditionTabWrapper>
            <ComponentRow gridTemplateColumns="125px 180px 1fr">
                <YearDropdown
                    label={`${_labelPrefix} Year`}
                    formik={formik}
                    fieldName={`marine.engines.[${index}].year`}
                    assetSubtype={AssetSubtype.MARINE_ENGINE}
                    selectedYear={engine.year}
                    condition={engine.condition}
                    prefilled={prefilled}
                />
                <MakeDropdown
                    formik={formik}
                    fieldNamePrefix={`marine.engines[${index}]`}
                    condition={engine.condition}
                    assetSubtype={AssetSubtype.MARINE_ENGINE}
                    label={`${_labelPrefix} Make`}
                    prefilled={prefilled}
                />
                <FormikTextInput
                    name={`marine.engines.[${index}].model`}
                    label={`${_labelPrefix} Model`}
                    disabled={!engine.make}
                    prefilled={prefilled}
                />
            </ComponentRow>
        </div>
    )
}

export default MotorFields
